// @flow
import api from "api";
import * as resources from "resources";

export const fetchGlobals = () => {
  return api.get(resources.DataGET.GLOBALS);
};
